<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>assessment</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">Nueva cuenta contable</h2>
        <p class="cf-dlg-subtitle">Rellena los datos de la nueva cuenta</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body">
      <form onkeypress="return event.keyCode != 13;">

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput name="accountingAccounts.name" required
            [(ngModel)]="accountingAccounts.name">
          <mat-error *ngIf="nameLengthError">Máximo 125 caracteres permitidos</mat-error>
        </mat-form-field>

        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Número de cuenta (10 dígitos)</mat-label>
          <input type="text" matInput name="accountingAccounts.number"
            minlength="10" maxlength="10" required
            [(ngModel)]="accountingAccounts.number"
            (keydown.enter)="keyDownTabPress($event)">
          <mat-error *ngIf="numberLengthError">El número debe tener exactamente 10 dígitos</mat-error>
        </mat-form-field>

        <app-select name="accountingAccounts.type" [(ngModel)]="accountingAccounts.type"
          [config]="{ label: 'Tipo', required: true, options: accountingAccountsTypeOptions }">
        </app-select>

      </form>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save(accountingAccounts)">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
